module.exports = __webpack_public_path__ + "img/logo.30a3e166.png";